exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "div.provider-panel--1Ppr_ZAf6Mgzqttq-7sU7- {\n  color: #265b91;\n}\n\ndiv.provider-panel--1Ppr_ZAf6Mgzqttq-7sU7- a.provider-panel--1pWS9_IWITj_1aKCdidaM5 {\n  cursor: pointer;\n  font-weight: 500;\n}\n", ""]);

// exports
exports.locals = {
	"editButtonContainer": "provider-panel--1Ppr_ZAf6Mgzqttq-7sU7-",
	"editButtonContainer": "provider-panel--1Ppr_ZAf6Mgzqttq-7sU7-",
	"editButton": "provider-panel--1pWS9_IWITj_1aKCdidaM5",
	"editButton": "provider-panel--1pWS9_IWITj_1aKCdidaM5"
};